import React from "react";
import { IronManModelProps } from "@/types/laser-engraving";

/**
 * IronMan模型组件
 *
 * 专门负责渲染处理后的IronMan模型，具有以下特性：
 * - 支持多部件模型渲染
 * - 保持原始材质和纹理
 * - 优化的渲染性能
 * - 条件显示控制
 */
export const IronManModel = React.memo<IronManModelProps>(
  ({ models, position = [0, 0, 0], visible = true }) => {
    console.log("🎯 IronManModel 渲染", {
      visible,
      modelCount: models.length,
      position,
    });

    // 如果不可见或没有模型数据，不渲染
    if (!visible || models.length === 0) {
      return null;
    }

    return (
      <group position={position}>
        {models.map((modelData, index) => (
          <mesh
            key={`ironman-part-${index}`}
            geometry={modelData.geometry}
            material={modelData.material}
            castShadow={true}
            receiveShadow={true}
          />
        ))}
      </group>
    );
  },
);

IronManModel.displayName = "IronManModel";

export default IronManModel;
